import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useLoginStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  card: {
    width: "100%",
    maxWidth: "350px",
    ...shorthands.padding("24px"),
    borderRadius: "8px",
    boxShadow: tokens.shadow16,
  },
  header: {
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    gap: tokens.spacingHorizontalM,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalM,
  },
  input: {
    borderRadius: "4px",
  },
  button: {
    marginTop: tokens.spacingVerticalL,
    position: "relative",
  },
  icon: {
    marginRight: tokens.spacingHorizontalS,
  },
  responseContainer: {
    marginTop: tokens.spacingVerticalL,
    textAlign: "center",
  },
  successText: {
    color: tokens.colorPaletteGreenForeground1,
  },
  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: "12px",
    overflow: "scroll",
  },
  loading: {
    position: "absolute",
    right: "10px",
  },
});
